<script>
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import FilterBar from '../../components/filter_bar.svelte'
  import EntityList from '../../components/entity/entity_list.svelte'
  import Paginator from '../../components/paginator.svelte'
  import FilterTabs from '../../components/filter_tabs.svelte'
  import FilterSelect from '../../components/filter_select.svelte'

  let {
    media_uploads = [],
    pagy = { page: 1, pages: 1, count: 0 },
    total_count = null,
    mode = 'failed',
    filters = {},
    failure_reason_options = []
  } = $props()

  const TABS = [
    { key: 'failed', label: 'Failed' },
    { key: 'expired', label: 'Expired' },
    { key: 'all', label: 'All' }
  ]

  const SORT_OPTIONS = [
    { value: 'newest', label: 'Newest first' },
    { value: 'oldest', label: 'Oldest first' }
  ]

  const EMPTY_MESSAGES = {
    failed: 'No failed uploads.',
    expired: 'No expired uploads.',
    all: 'No media uploads found.'
  }
</script>

<Layout>
  <PageHeader title="Failed Uploads" subtitle="Quest and avatar uploads that never finished" count={pagy.count} total={total_count} />

  <FilterBar>
    {#snippet start()}
      <FilterTabs tabs={TABS} active={mode} param="mode" />
    {/snippet}
  </FilterBar>

  <FilterBar>
    {#snippet start()}
      {#if mode !== 'expired'}
        <FilterSelect
          label="Failure Reason"
          param="failure_reason"
          value={filters.failure_reason || ''}
          placeholder="Any"
          options={failure_reason_options}
        />
      {/if}
      <FilterSelect label="Sort" param="sort" value={filters.sort} placeholder={null} options={SORT_OPTIONS} />
    {/snippet}
  </FilterBar>

  <EntityList entity="media_upload" rows={media_uploads} emptyMessage={EMPTY_MESSAGES[mode]} />

  <Paginator {...pagy} />
</Layout>
